/**
 * Swiper-powered announcement bar slider.
 * Touch/swipe enabled; no navigation buttons.
 */
class NeoAnnouncementBar extends HTMLElement {
  /** @type {import('swiper').default | null} */
  #swiper = null;

  connectedCallback() {
    const swiperElement = this.querySelector('[data-neo-announcement-swiper]');
    const slides = this.querySelectorAll('.swiper-slide');

    if (!swiperElement || slides.length <= 1) return;

    const SwiperConstructor = window.Swiper;

    if (!SwiperConstructor) return;

    const autoplayDelay = Number(this.dataset.autoplayDelay);

    const scheduleInit = window.requestIdleCallback ?? ((callback) => setTimeout(callback, 0));

    scheduleInit(() => {
      this.#swiper = new SwiperConstructor(swiperElement, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        allowTouchMove: true,
        touchEventsTarget: 'container',
        grabCursor: true,
        autoplay: Number.isFinite(autoplayDelay) && autoplayDelay > 0
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      });
    });
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }
}

if (!customElements.get('neo-announcement-bar')) {
  customElements.define('neo-announcement-bar', NeoAnnouncementBar);
}
